import { render, staticRenderFns } from "./SteperContainer.vue?vue&type=template&id=2886917a&scoped=true"
import script from "./SteperContainer.vue?vue&type=script&lang=ts"
export * from "./SteperContainer.vue?vue&type=script&lang=ts"
import style0 from "./SteperContainer.vue?vue&type=style&index=0&id=2886917a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886917a",
  null
  
)

export default component.exports